import { flattenSequentialMonadicQuestions, QUESTION_TYPES } from '@api/instant_survey';

import { SURVEY_QUESTION_FIELDS_TO_MERGE } from './constants';

const getMergedQuestion = ({ externalQuestion, fields, surveyQuestion }) => {
  const mergedFields = fields.reduce((acc, field) => {
    if (surveyQuestion?.[field] !== undefined) acc[field] = surveyQuestion[field];
    return acc;
  }, {});

  return { ...externalQuestion, ...mergedFields };
};

export const mergeExternalQuestionsWithSurvey = ({ externalQuestions, surveyQuestions }) => {
  if (!Array.isArray(externalQuestions)) return [];

  const surveyQuestionsBySourceId = new Map();
  const surveySubQuestionsBySourceId = new Map();
  (surveyQuestions || []).forEach((question) => {
    if (question?.questionSourceId) {
      surveyQuestionsBySourceId.set(String(question.questionSourceId), question);
    }

    if (question?.type !== QUESTION_TYPES.SEQUENTIAL_MONADIC.value) return;

    (question.subQuestions || []).forEach((subQuestion) => {
      if (!subQuestion?.questionSourceId) return;
      surveySubQuestionsBySourceId.set(String(subQuestion.questionSourceId), subQuestion);
    });
  });

  return externalQuestions.flatMap((externalQuestion) => {
    const match = surveyQuestionsBySourceId.get(String(externalQuestion.id));
    const mergedQuestion = match
      ? getMergedQuestion({
          externalQuestion,
          fields: SURVEY_QUESTION_FIELDS_TO_MERGE,
          surveyQuestion: match,
        })
      : externalQuestion;

    if (mergedQuestion.type !== QUESTION_TYPES.SEQUENTIAL_MONADIC.value) {
      return [mergedQuestion];
    }

    const surveySubQuestions = match?.subQuestions || [];
    const externalSubQuestions = externalQuestion.subQuestions || [];
    const subQuestions = externalSubQuestions.length
      ? externalSubQuestions.map((externalSubQuestion, index) => {
          const subQuestionMatch =
            surveySubQuestionsBySourceId.get(String(externalSubQuestion.id)) ||
            surveySubQuestions[index];

          if (!subQuestionMatch) return externalSubQuestion;

          return getMergedQuestion({
            externalQuestion: externalSubQuestion,
            fields: [...SURVEY_QUESTION_FIELDS_TO_MERGE, 'subQuestions', 'type'],
            surveyQuestion: subQuestionMatch,
          });
        })
      : surveySubQuestions;

    return flattenSequentialMonadicQuestions([
      {
        ...mergedQuestion,
        concepts: match?.concepts || mergedQuestion.concepts || [],
        subQuestions,
      },
    ]);
  });
};
